import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useContext } from '@nuxtjs/composition-api';
import { IRarity } from '~/types/collections';


export default /*#__PURE__*/_defineComponent({
  __name: 'RarityIcon',
  props: {
    type: null,
    rarity: null,
    height: null,
    width: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as { type?: string, rarity?: IRarity | null, height?: string, width?: string };



const {} = useContext();

const rarityStyles = computed(() => {
  const styles = {
    color: props.rarity?.hex,
  };
  return styles;
});

return { __sfc: true,emit, props, rarityStyles }
}

})